"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface TradePayablesTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  // Add questions here when available
];

export default function TradePayablesTailoringQuestions({ onBack }: TradePayablesTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Trade Payables"
      title="Trade Payables - Tailoring Questions"
      description="Answer entity-specific questions for Trade Payables"
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}

